export const excludedReportsTitles = [
  "PRODUCT_INFORMATION",
  "BIM Data",
  "PRODUCT_CONFIGURATOR_CERTIFICATE",
  "PRODUCT_CONFIGURATOR_MANUALS",
  "LCA_REPORT",
];

export const items = [
  {
    title: "PRODUCT_INFORMATION",
    id: "PRODUCT_INFORMATION",
    checkboxContent: [
      {
        id: "PRODUCT_INFORMATION_REPORT",
        title: "PRODUCT_INFORMATION_REPORT",
        extension: "pdf",
        fileName:
          "IM_2018_06_A00000054447 | Installation manual | 1,2 MB | pdf",
        checked: false,
      },
    ],
    extension: "pdf",
    checked: false,
  },
  // {
  //   title: "SPECIFICATION_TEXT",
  //   checkboxContent: [
  //     {
  //       id: 1,
  //       title: "Installation manual Air terminal devices",
  //       fileName:
  //         "IM_2018_06_A00000054447 | Installation manual | 1,2 MB | pdf",
  //     },
  //   ],
  //   checked: false,
  // },
  {
    title: "BIM_DATA",
    id: "BIM_DATA",
    checkboxContent: [
      {
        id: "BIM_DATA_REPORT",
        title: "BIM Data",
        extension: "xml",
        fileName:
          "IM_2018_06_A00000054447 | Would be nice to have some strings here | 1,2 MB | xml",
      },
    ],
    checked: false,
    extension: "xml",
  },
  {
    title: "PRODUCT_CONFIGURATOR_MANUALS",
    id: "PRODUCT_CONFIGURATOR_MANUALS",
    checkboxContent: [],
    checked: false,
  },
  {
    title: "PRODUCT_CONFIGURATOR_CERTIFICATE",
    id: "PRODUCT_CONFIGURATOR_CERTIFICATE",
    checkboxContent: [],
    checked: false,
  },
  {
    title: "LCA_REPORT",
    id: "LCA_REPORT",
    checkboxContent: [
      {
        id: "LCA_DATA_REPORT",
        title: "LCA REPORT",
        extension: "pdf",
        fileName: "LCA Document",
      },
    ],
    checked: false,
    extension: "pdf",
  },
];

export const systemExportItems = [
  {
    title: "PROJECT_REPORT",
    id: 1,
    checkboxContent: [
      {
        id: "Project Report",
        checked: true,
        // title: "Installation manual Air terminal devices",
        // fileName:
        //   "IM_2018_06_A00000054447 | Installation manual | 1,2 MB | pdf",
      },
    ],
    checked: true,
    skipContentRender: true,
    collapsable: true,
  },
  // {
  //   title: "BIM Data",
  //   content: [
  //     {
  //       id: 1,
  //       title: "Installation manual Air terminal devices",
  //       fileName:
  //         "IM_2018_06_A00000054447 | Installation manual | 1,2 MB | pdf",
  //     },
  //   ],
  //   checked: true,
  // },
  {
    title: "PRODUCT_LIST",
    id: 2,
    checkboxContent: [
      {
        id: "BOM",
        checked: true,
        // title: "Installation manual Air terminal devices",
        // fileName:
        //   "IM_2018_06_A00000054447 | Installation manual | 1,2 MB | pdf",
      },
    ],
    checked: true,
    skipContentRender: true,
    collapsable: true,
  },
  {
    title: "BOM_UNMITIGATED",
    id: 3,
    checkboxContent: [
      {
        id: "BOM_UNMITIGATED",
        checked: true,
        // title: "Installation manual Air terminal devices",
        // fileName:
        //   "IM_2018_06_A00000054447 | Installation manual | 1,2 MB | pdf",
      },
    ],
    checked: true,
    skipContentRender: true,
    collapsable: true,
  },
  // {
  //   title: "System Description",
  //   content: [
  //     {
  //       id: 1,
  //       title: "Installation manual Air terminal devices",
  //       fileName:
  //         "IM_2018_06_A00000054447 | Installation manual | 1,2 MB | pdf",
  //     },
  //   ],
  //   checked: true,
  // },
];

export const wizardExportItems = [
  {
    title: "TENDER_TEXT_REPORT",
    id: 5,
    checkboxContent: [
      {
        id: "Tender Text",
      },
    ],
    checked: true,
    skipContentRender: true,
  },
];

// export const productDataItems = [
//   {
//     title: "Airnamic",
//     sublist: false,
//     content: [
//       {
//         id: 1,
//         title: "Installation manual Air terminal devices",
//         fileName:
//           "IM_2018_06_A00000054447 | Installation manual | 1,2 MB | pdf",
//       },
//     ],
//     checked: true,
//   },
//   {
//     title: "TVE",
//     sublist: true,
//     content: items,
//     checked: true,
//   },
// ];
